/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ExploreActiveItemResponse } from './ExploreActiveItemResponse'
import {
  ExploreActiveItemResponseFromJSON,
  ExploreActiveItemResponseFromJSONTyped,
  ExploreActiveItemResponseToJSON,
} from './ExploreActiveItemResponse'

/**
 *
 * @export
 * @interface ExploreActiveItemResponseWrapper
 */
export interface ExploreActiveItemResponseWrapper {
  /**
   *
   * @type {ExploreActiveItemResponse}
   * @memberof ExploreActiveItemResponseWrapper
   */
  readonly success?: ExploreActiveItemResponse | null
  /**
   *
   * @type {string}
   * @memberof ExploreActiveItemResponseWrapper
   */
  error?: string | null
}

/**
 * Check if a given object implements the ExploreActiveItemResponseWrapper interface.
 */
export function instanceOfExploreActiveItemResponseWrapper(
  value: object,
): boolean {
  let isInstance = true

  return isInstance
}

export function ExploreActiveItemResponseWrapperFromJSON(
  json: any,
): ExploreActiveItemResponseWrapper {
  return ExploreActiveItemResponseWrapperFromJSONTyped(json, false)
}

export function ExploreActiveItemResponseWrapperFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExploreActiveItemResponseWrapper {
  if (json === undefined || json === null) {
    return json
  }
  return {
    success: !exists(json, 'success')
      ? undefined
      : ExploreActiveItemResponseFromJSON(json['success']),
    error: !exists(json, 'error') ? undefined : json['error'],
  }
}

export function ExploreActiveItemResponseWrapperToJSON(
  value?: ExploreActiveItemResponseWrapper | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    error: value.error,
  }
}
